export default path => '/my-account/vehicles'.includes(path)
